var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack248({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.74,10.31H7.24v-.4a2.6,2.6,0,0,1,.24-1.19,3.81,3.81,0,0,1,1-1.06A8.1,8.1,0,0,0,9.3,6.9a1.07,1.07,0,0,0,.21-.64,1,1,0,0,0-.38-.82,1.47,1.47,0,0,0-1-.34,1.56,1.56,0,0,0-1,.36,1.85,1.85,0,0,0-.58,1.09L5,6.36a2.48,2.48,0,0,1,.89-1.78A3.16,3.16,0,0,1,8,3.84a3.25,3.25,0,0,1,2.25.75,2.22,2.22,0,0,1,.84,1.72,1.85,1.85,0,0,1-.31,1A6.47,6.47,0,0,1,9.5,8.67a2.52,2.52,0,0,0-.65.69A2.42,2.42,0,0,0,8.74,10.31Zm-1.5,2.21V10.88H8.89v1.64Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack248);
export default __webpack_public_path__ + "static/media/Symbolpack_2_48.a04029c3e044f3965544382ab11f85df.svg";
export { ForwardRef as ReactComponent };